import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CustomerServiceModule } from '@app/shared/customer-service/customer-service.module';
import { ProductModule } from '@app/shared/product/product.module';
import { ReviewListModule } from '@app/shared/review/review-list/review-list.module';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { CarouselModule } from 'outshared-lib';
import { MeningButtonModule } from '../mening-button/mening-button.module';
import { ReviewsModule } from './reviews/reviews.module';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        ProductModule,
        CarouselModule,
        LazyLoadImageModule,
        CustomerServiceModule,
        ReviewsModule,
        MeningButtonModule,
        ReviewListModule,
    ],
    exports: [
        ReviewsModule,
        ReviewListModule,
    ],
})
export class ReviewModule {
}
